var Position;
(function (Position) {
  Position["BOTTOM"] = "bottom";
  Position["BOTTOM_LEFT"] = "bottom-left";
  Position["BOTTOM_RIGHT"] = "bottom-right";
  Position["CENTER"] = "center";
  Position["LEFT"] = "left";
  Position["LEFT_TOP"] = "left-top";
  Position["RIGHT"] = "right";
  Position["RIGHT_TOP"] = "right-top";
  Position["TOP"] = "top";
})(Position || (Position = {}));

export { Position };
//# sourceMappingURL=position.mjs.map
